import React from 'react'
import Banner from '../../components/Banner/Banner'
import CareersImage from "../../assets/aboutpage/careersImage.jpeg"
import './Careers.scss'
import Footer from '../../components/Footer/Footer'
import CareersSection from '../../components/AboutComponents/CareersSection/CareersSection'
import BannerBar from '../../components/BannerBar/BannerBar'

const Careers = () => {
  return (
    <div>
        
        <Banner title="About Us" subtitle="Careers" image={CareersImage} />
        <BannerBar />
        <CareersSection />
        <Footer />
    </div>
  )
}

export default Careers